import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Survey } from '../../../models/roiSurvey/survey';
import { Pages } from '../../../models/roiSurvey/pages';
import { Intervents } from '../../../models/roiSurvey/intervents';
import { Items } from '../../../models/roiSurvey/items';
import { ModuleService } from '../services/module.service';
import { MatPaginator } from '@angular/material';

@Component({
  selector: 'app-modal-survey-roi',
  templateUrl: './modal-survey-roi.component.html',
  styleUrls: ['./modal-survey-roi.component.css']
})
export class ModalSurveyRoiComponent implements OnInit {
  @Input() idElaboration;
  @Input() planInterventDate;
  @Input() itemState;
  @Output() surveyModalEvent: EventEmitter<string> = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  facility = JSON.parse(this.localFacilities);
  id = JSON.parse(this.localID);
  modules = JSON.parse(this.localModules);

  currentFacility = this.facility[this.id];

  //Roi survey Object
  roiSurvey: any;
  surveyObject: Survey;
  pageObject: Pages;
  interventObject: Intervents;
  itemObject: Items;

  //Array for button radio
  answerButtonRadio: Array<string> = ['Si', 'No'];
  //Map for answer value.
  answerMap: Map<number, string> = new Map();

  //ItemsPage and CurrentPage
  pageIndex: number = 1;
  pageSize: number = 5;

  //Variable that show and hide button for save survey
  showButtonSend: boolean;

  surveyState: string;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private moduleService: ModuleService,
    private modal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
    this.readSurveyRoi(this.pageIndex, this.pageSize);
  }

  //Method that close modal.
  close() {
    this.surveyModalEvent.emit(this.surveyState);
    this.modal.close();
  }

  //API read Survey Roi
  readSurveyRoi(pageIndex: number, pageSize: number) {
    this.moduleService.getSurvey(this.currentFacility.myFacilities.ID, this.idElaboration, pageIndex, pageSize)
      .subscribe(
        data => {
          this.roiSurvey = data;
          this.setSurveyObject(this.roiSurvey);
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }

  //API save Survey Roi
  saveSurveyRoi() {
    this.moduleService.saveSurvey(this.surveyObject)
      .subscribe(
        res => {
          console.log(res);
        },
        error => {
          console.log(error);
        });
  }

  //Method that set from event value of radio button to Map.
  getValueFromButton(event, answerID) {
    this.answerMap.set(answerID, event.value);
  }

  //Method that set from event value of TextArea to Map.
  getValueFromText(event, answerID) {
    this.answerMap.set(answerID, event.srcElement.value);
  }

  // Method to intercept paginator event
  onPaginateChange(event) {
    this.showButtonSend = this.paginator.hasNextPage();
    this.readSurveyRoi(event.pageIndex + 1, event.pageSize);

    let goBackButton: boolean = event.previousPageIndex < event.pageIndex;

    if (goBackButton) {
      this.fillPartialSurveyRoiObject();
    }
  }

  filledSurvetPaginate(event) {
    this.readSurveyRoi(event.pageIndex + 1, event.pageSize);
  }

  // Method that fill survey object
  setSurveyObject(roiSurvey: any) {
    this.surveyObject = new Survey;
    this.surveyObject.ID = roiSurvey.ID;
    this.surveyObject.InterventionsCount = roiSurvey.InterventionsCount;
    this.surveyObject.isCompleted = false;

    for (let page of roiSurvey.Pages) {
      this.pageObject = new Pages;
      this.pageObject.PageNumber = page.PageNumber;

      for (let intervent of page.Intervents) {
        this.interventObject = new Intervents;
        this.interventObject.DescrizioneIntervento = intervent.DescrizioneIntervento;

        for (let item of intervent.Items) {
          this.itemObject = new Items
          this.itemObject.ID = item.ID;
          this.itemObject.AnswerBool = item.AnswerBool;
          this.itemObject.AnswerText = item.AnswerText;
          this.itemObject.Position = item.Position;
          this.itemObject.Type = item.Type;
          this.itemObject.Question = item.Question
          this.interventObject.Items.push(this.itemObject);
        }
        this.pageObject.Intervents.push(this.interventObject);
      }
      this.surveyObject.Pages.push(this.pageObject);
    }
  }

  //Method that fill Partial survey object
  fillPartialSurveyRoiObject() {
    this.surveyObject.isCompleted = false;
    for (let page of this.surveyObject.Pages)
      for (let intervent of page.Intervents)
        for (let item of intervent.Items) {

          if (this.answerMap.has(item.ID) && (this.answerMap.get(item.ID) === 'Si' || this.answerMap.get(item.ID) === 'Yes')) {
            item.AnswerBool = true;
            item.AnswerText = this.answerMap.get(item.ID);
          }

          if (this.answerMap.has(item.ID) && (this.answerMap.get(item.ID) === 'No')) {
            item.AnswerBool = false;
            item.AnswerText = this.answerMap.get(item.ID);
          }

          if (this.answerMap.has(item.ID) && (this.answerMap.get(item.ID) !== 'Si' && this.answerMap.get(item.ID) !== 'No'))
            item.AnswerText = this.answerMap.get(item.ID);

          if (!this.answerMap.has(item.ID)) {
            item.AnswerText = item.AnswerText;
            item.AnswerBool = item.AnswerBool;
          }
        }
    this.saveSurveyRoi();
    this.surveyState = 'Partial';

    if (this.pageSize <= 5)
      this.close();
  }

  //Method that fill Complete survey object
  fillTotalSurveyRoiObject() {
    this.surveyObject.isCompleted = true;
    for (let page of this.surveyObject.Pages)
      for (let intervent of page.Intervents)
        for (let item of intervent.Items) {

          if (this.answerMap.has(item.ID) && (this.answerMap.get(item.ID) === 'Si' || this.answerMap.get(item.ID) === 'Yes')) {
            item.AnswerBool = true;
            item.AnswerText = this.answerMap.get(item.ID);
          }

          if (this.answerMap.has(item.ID) && (this.answerMap.get(item.ID) === 'No')) {
            item.AnswerBool = false;
            item.AnswerText = this.answerMap.get(item.ID);
          }

          if (this.answerMap.has(item.ID) && (this.answerMap.get(item.ID) !== 'Si' && this.answerMap.get(item.ID) !== 'No'))
            item.AnswerText = this.answerMap.get(item.ID);

          if (!this.answerMap.has(item.ID)) {
            item.AnswerText = item.AnswerText;
            item.AnswerBool = item.AnswerBool;
          }
        }
    this.saveSurveyRoi();
    this.surveyState = 'Complete';
    this.close();
  }

}
